import {TestIdProps} from 'shared/web';

import {ButtonProps} from '../Button/Button';
import {Status} from '../Status/Status';
import {useTranslationContext} from '../TranslationProvider/TranslationContext';

interface RestrictedStatusProps extends TestIdProps {
  headline?: string;
  subheadline?: string;
  action?: Pick<ButtonProps, 'onClick' | 'title' | 'isDisabled' | 'leftIcon'>;
}

export function RestrictedStatus(props: RestrictedStatusProps) {
  const t = useTranslationContext();

  return (
    <Status
      icon="hardware/security"
      headline={props.headline ?? t('general.labels.error')}
      subheadline={props.subheadline}
      action={props.action}
      severity="warning"
      data-testid={props['data-testid']}
    />
  );
}
